import React, { useEffect, useState } from "react";
import { Buttons, MainCol, MainContainer, MainRow } from "components/common";
import CollectionCard from "./collectionCard";
import {
  CardMainFlex,
  CollapseMain,
  FilterRow,
  FilterTab,
  FilterTabPanel,
  MainCollectionDetails,
  SearchInput,
  ToggleButton,
  PriceSelect,
  PriceSelectOption,
} from "./styles";
import Form from "react-bootstrap/Form";

import { AiOutlineFilter } from "react-icons/all";
import { SearchOutlined } from "@ant-design/icons";
import * as C from "../collection/collectionElement";
import { useAppSelector } from "store/store";
import { AddFavouriteHook, RemoveFavouriteHook } from "hooks";
import { CommonUtility } from "utility";
import { blockchainSelect } from "components/data/selectData";

const DetailsCollection = ({
  data,
  setSort,
  sort,
  setFilterData,
  dataFilter,
  refetch,
  attributes,
}) => {
  const [filter, setFilter] = useState(true);
  const [priceFilter, setPriceFilter] = useState({
    type: "",
    max: "",
    min: "",
  });
  //useAppSelector
  const { account } = useAppSelector((state) => state.web3Connect);

  //custom Hooks
  const { addFav, data: addFavData } = AddFavouriteHook();
  const { removeFav, data: removeFavData } = RemoveFavouriteHook();

  //useEffect
  useEffect(() => {
    (addFavData || removeFavData) && refetch();
  }, [addFavData, removeFavData]);

  return (
    <MainCollectionDetails>
      <MainContainer className="collectionContainer">
        {/* FilterRow */}
        {/* <MainRow>
          <button style={{ width: "5rem" }} onClick={() => setFilter(!filter)}>
            Filter
          </button>
        </MainRow> */}
        <FilterRow>
          <div className="divTab ">
            <AiOutlineFilter
              className={filter ? "filterIcon " : "filterIcon active"}
              size={22}
              onClick={() => setFilter(!filter)}
            />

            <div>
              <FilterTab defaultActiveKey="1">
                <FilterTabPanel tab="Items" key="1"></FilterTabPanel>
                {/* <FilterTabPanel
                  tab="Activity"
                  key="2"
                  disabled
                ></FilterTabPanel> */}
              </FilterTab>
            </div>
          </div>
          <div className="searchMain">
            <div className="searchDiv">
              <SearchInput
                prefix={
                  <SearchOutlined
                    style={{
                      fontSize: "1px",
                      paddingLeft: "1rem",
                      color: " #7F8C8D",
                    }}
                  />
                }
                onChange={(e) =>
                  setFilterData({ ...dataFilter, name: e.target.value })
                }
                placeholder="Search By name"
              />
            </div>
            <div className="selectDiv">
              <PriceSelect
                onChange={(e) => setSort({ ...sort, price: e })}
                defaultValue="Price High To Low"
              >
                <PriceSelectOption value="high">
                  Price High To Low
                </PriceSelectOption>
                <PriceSelectOption value="low">
                  Price Low To High
                </PriceSelectOption>
              </PriceSelect>
            </div>
          </div>
        </FilterRow>
        {/* <hr /> */}
        {/* collection row */}
        <MainRow className="filterRow">
          <MainCol
            className={
              filter ? `col-lg-2 col-xs-12 sidebarCol ` : " d-none  hideScreen"
            }
          >
            <div className="filterDiv">
              <div className="flex justify-content-between filterFooter  ">
                <p className="buyTxt">Buy Now</p>
                <ToggleButton
                  onClick={(e, value) =>
                    setFilterData({ ...dataFilter, listed: e.target.checked })
                  }
                  type="switch"
                  id="mySwitch"
                />
              </div>
              <C.SidebarCollapse className="mt-3">
                <C.SidebarCollapsePanel header="Price" key="3">
                  <div className="minMaxMain">
                    <Form.Select
                      onChange={(e) =>
                        setPriceFilter({ ...priceFilter, type: e.target.value })
                      }
                    >
                      <option value="TestToken">TestToken</option>
                      <option value="USDC">USDC</option>
                    </Form.Select>
                    <div className="inputWrapper">
                      <input
                        disabled={!priceFilter.type}
                        onChange={(e) =>
                          setPriceFilter({
                            ...priceFilter,
                            min: e.target.value,
                          })
                        }
                        type="number"
                        placeholder="MIN"
                      />

                      <input
                        disabled={!priceFilter.type}
                        onChange={(e) =>
                          setPriceFilter({
                            ...priceFilter,
                            max: e.target.value,
                          })
                        }
                        type="number"
                        placeholder="MAX "
                      />
                    </div>
                    <Buttons
                      disabled={Object.values(priceFilter).some(
                        (n) => n.trim() === ""
                      )}
                      onClick={() =>
                        setFilterData({ ...dataFilter, price: priceFilter })
                      }
                      explore
                      className="mt-2"
                    >
                      Apply
                    </Buttons>
                  </div>
                </C.SidebarCollapsePanel>
              </C.SidebarCollapse>
              {/* <p className="priceRange mt-3">Price Range (ETH)</p> */}

              {/* <input
                className="filterInput"
                type="text"
                placeholder="Filter properties "
              /> */}
              <div>
                <C.SidebarCollapse>
                  <C.SidebarCollapsePanel header="Chain" key="3">
                    <MainRow>
                      {blockchainSelect.map((item2) => (
                        <>
                          <MainCol lg={12}>
                            <div>
                              <C.ChainSelect
                                onChange={(e) => {
                                  if (
                                    dataFilter?.chain &&
                                    dataFilter.chain.length > 0
                                  ) {
                                    if (e.target.checked) {
                                      setFilterData({
                                        ...dataFilter,
                                        chain: [...dataFilter.chain, item2.value],
                                      });
                                    } else {
                                      const newChain = dataFilter.chain.filter(
                                        (x) => x !== item2.value
                                      );
                                      setFilterData({
                                        ...dataFilter,
                                        chain: newChain,
                                      });
                                    }
                                  } else
                                    setFilterData({
                                      ...dataFilter,
                                      chain: [item2.value],
                                    });
                                }}
                              />{" "}
                              <span
                                className="ms-3"
                                style={{
                                  fontWeight: "500",
                                  fontSize: "1rem",
                                }}
                              >
                                {item2?.text}
                              </span>
                            </div>
                          </MainCol>
                          {item2?.checkboxCount && (
                            <MainCol lg={12}>
                              <C.BodyText>{item2?.checkboxCount}</C.BodyText>
                            </MainCol>
                          )}
                        </>
                      ))}
                    </MainRow>
                  </C.SidebarCollapsePanel>
                </C.SidebarCollapse>

                {attributes &&
                  Object.keys(attributes).map((trait) => {
                    return (
                      <C.SidebarCollapse>
                        <C.SidebarCollapsePanel header={trait} key="3">
                          <MainRow>
                            {attributes[trait].map((value) => (
                              <>
                                <MainCol lg={12}>
                                  <div>
                                    <C.ChainSelect
                                      onChange={(e) => {
                                        if (dataFilter?.attributes) {
                                          let traitValues =
                                            dataFilter.attributes[trait];
                                          if (traitValues) {
                                            if (e.target.checked) {
                                              traitValues.push(value);
                                              setFilterData({
                                                ...dataFilter,
                                                attributes: {
                                                  ...dataFilter.attributes,
                                                  [trait]: traitValues,
                                                },
                                              });
                                            } else {
                                              const index =
                                                traitValues.indexOf(value);
                                              traitValues.splice(index, 1);
                                              if (traitValues.length < 1) {
                                                const attr =
                                                  dataFilter.attributes;
                                                delete attr[trait];
                                                setFilterData({
                                                  ...dataFilter,
                                                  attributes: attr,
                                                });
                                              } else {
                                                setFilterData({
                                                  ...dataFilter,
                                                  attributes: {
                                                    ...dataFilter.attributes,
                                                    [trait]: traitValues,
                                                  },
                                                });
                                              }
                                            }
                                          } else {
                                            setFilterData({
                                              ...dataFilter,
                                              attributes: {
                                                ...dataFilter.attributes,
                                                [trait]: [value],
                                              },
                                            });
                                          }
                                        } else
                                          setFilterData({
                                            ...dataFilter,
                                            attributes: {
                                              [trait]: [value],
                                            },
                                          });
                                      }}
                                    />{" "}
                                    <span
                                      className="ms-3"
                                      style={{
                                        fontWeight: "500",
                                        fontSize: "1rem",
                                      }}
                                    >
                                      {value}
                                    </span>
                                  </div>
                                </MainCol>
                              </>
                            ))}
                          </MainRow>
                        </C.SidebarCollapsePanel>
                      </C.SidebarCollapse>
                    );
                  })}
              </div>
            </div>
          </MainCol>
          <MainCol
            className={filter ? "col-lg-10 col-xs-12 rightCol" : "col-lg-12"}
          >
            <CardMainFlex className="cardMainFlex  ">
              {data?.map((item) => {
                const fav = item.favourites.find(
                  (x) => x.user_address === account?.toLocaleLowerCase()
                );
                const user =
                  account?.toLocaleLowerCase() === item.owner_address;
                const data = {
                  changeFav: fav ? removeFav : addFav,
                  favId: fav?.id,
                  user,
                  metadata: {
                    id: user ? item.nft_id : item?.sellNft?.id,
                    price: item?.sellNft?.signed_order.erc20TokenAmount,
                    network: item.network_id,
                    erc20Token: item?.sellNft?.signed_order.erc20Token,
                    sold: item?.sellNft?.sold || (!item?.sellNft && !user),
                    token_id: CommonUtility.deStructureNftId(item.nft_id)
                      .tokenId,
                    name: item.name,
                  },
                  buttonTxt: item?.sellNft?.sold
                    ? "Sold Out"
                    : !item?.sellNft && !user
                    ? "Not listed"
                    : "Details",
                  image: item.image,
                  nft_id: item.nft_id,
                };
                return (
                  <div className={filter ? "cardItem" : "cardItem2"}>
                    <CollectionCard data={data} />
                  </div>
                );
              })}
            </CardMainFlex>
          </MainCol>
        </MainRow>
      </MainContainer>
    </MainCollectionDetails>
  );
};

export default DetailsCollection;
